import React from "react";
import styled from "styled-components";
import { theme, color as colors } from "@workboard/wobo-ui";
import { Tooltip } from "@workboard/wobo-ui";
import HelpOutline from "@material-ui/icons/HelpOutline";

const Title = styled("h3")``;
const Content = styled("section")``;

const Term = ({ className, title, children, helperText }) => (
  <section className={className}>
    <Title>
      {title}
      <Tooltip content={helperText} placement="top" arrow>
        <span>
          <HelpOutline className="icon" />
        </span>
      </Tooltip>
    </Title>
    <Content>{children}</Content>
  </section>
);

export default styled(Term)`
  display: grid;

  ${Title} {
    ${theme("--font-normal")};
    color: ${colors("--black-opacity-60")};
    display: inline-flex;
    margin-top: 10px;
    margin-bottom: 6px;
    font-size: 16px;
    font-weight: bold;
  }
  
  ${Tooltip} {
    margin-left: 8px;

    .icon {
      height; 16px;
      width: 16px;
      transform: translateY(-1.5px);
    }
  }

  ${Content} {
    font-size: 24px;
    font-weight: bold;
  }
`;
